import { useEffect, useState } from "react";
import { ArrowRight, CheckCircle2, ClipboardList, PackageCheck, Radio, TriangleAlert } from "lucide-react";
import { api, ApiError } from "../api";
import type { OrderSummary } from "../types";
import { statusLabels } from "../types";
import { Alert, formatDate, Loading, PageHeader } from "../components/Ui";
import { PendingStockReceipts } from "../components/PendingStockReceipts";

export function DashboardPage({ onOpenOrders, onOpenWarehouses }: { onOpenOrders: () => void; onOpenWarehouses: (warehouseId:string) => void }) {
  const [orders, setOrders] = useState<OrderSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [counts, setCounts] = useState({ new: 0, active: 0, ready: 0, issued: 0 });
  useEffect(() => {
    let stopped = false, inFlight = false;
    async function poll() {
      if (inFlight) return;
      inFlight = true;
      try {
        const result = await api.orderOverview();
        if (!stopped) { setOrders(result.items); setCounts(result); setError(""); }
      } catch (e) { if (!stopped) setError(e instanceof ApiError ? e.message : "Не удалось загрузить заказы"); }
      finally { inFlight = false; if (!stopped) setLoading(false); }
    }
    void poll(); const timer = window.setInterval(() => void poll(),10000);
    return () => { stopped = true; window.clearInterval(timer); };
  }, []);

  return <>
    <PageHeader eyebrow="Сегодня" title="Склад под контролем" text="Заказы из 1С и текущее состояние сборки." action={<button className="button button--primary" onClick={onOpenOrders}>Открыть заказы <ArrowRight size={18} /></button>} />
    {error && <Alert>{error}</Alert>}
    <div className="metrics-grid">
      <article className="metric-card metric-card--accent"><span className="metric-icon"><Radio /></span><div><small>Новые заказы</small><b>{loading ? "…" : counts.new}</b><p>ожидают назначения</p></div></article>
      <article className="metric-card"><span className="metric-icon"><ClipboardList /></span><div><small>В работе</small><b>{loading ? "…" : counts.active}</b><p>собираются сейчас</p></div></article>
      <article className="metric-card"><span className="metric-icon"><PackageCheck /></span><div><small>Готовы</small><b>{loading ? "…" : counts.ready}</b><p>можно выдавать</p></div></article>
      <article className="metric-card"><span className="metric-icon"><CheckCircle2 /></span><div><small>Выданы</small><b>{loading ? "…" : counts.issued}</b><p>всего в WMS</p></div></article>
    </div>
    <PendingStockReceipts onOpenWarehouses={onOpenWarehouses} />
    <section className="panel">
      <header className="panel__header"><div><h2>Последние заказы</h2><p>Живая очередь поступлений из 1С</p></div><button className="text-button" onClick={onOpenOrders}>Все заказы <ArrowRight size={16} /></button></header>
      {loading ? <Loading /> : orders.length === 0 ? <div className="empty-inline"><TriangleAlert />Заказы ещё не поступали из 1С.</div> :
        <div className="table-wrap"><table><thead><tr><th>Заказ</th><th>Клиент</th><th>Склад</th><th>Получен</th><th>Статус</th></tr></thead><tbody>
          {orders.slice(0, 8).map(order => <tr key={order.id}><td><b>№ {order.number}</b><small>{order.linesCount} позиций</small></td><td>{order.customer}</td><td>{order.warehouse}</td><td>{formatDate(order.orderedAt)}</td><td><span className={`status status--${order.status.toLowerCase()}`}>{statusLabels[order.status]}</span></td></tr>)}
        </tbody></table></div>}
    </section>
  </>;
}

